// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"467":"2921bbb253c2817e","761":"26285d5950a11f5e"}[chunkId] + ".js";
};